import React, { useEffect, useState } from "react";
import "./TransactionTab.scss";
import { listVouchers } from "../../util/API/reporting";
import CustomerTransactionTable from "../CustomerTransactionTable/CustomerTransactionTable";
import { getExternalAccounts, getExternalAccountBalance } from "../../util/API/externalaccounts";
import { Box, Select, Typography, MenuItem, IconButton } from "@mui/material";
import pdfImage from "../../images/pdf-image.svg"
import csvImage from "../../images/excel-image.svg"
import { CSVLink } from "react-csv";
import { runPDFTH, runPDFVH, deleteFile } from "../../util/API/reporting";
import DynamicFilter from "../UI/DynamicFilter/DynamicFilter";
import BaseButton from "../UI/BaseButton/BaseButton";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

function TransactionTab({
  selectedUser,
  selectedUserData,
  setSelectedUserData,
  type
}) {
  const [transactionHistory, setTransactionHistory] = useState();
  const [loading, setLoading] = useState(true);
  const [externalAccounts, setExternalAccounts] = useState([]);
  const [selectedExternalAccount, setSelectedExternalAccount] = useState(null);
  const [table, setTable] = useState(null);
  const [csvData, setCsvData] = useState(null);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState({
    user: [],
    type: [],
  });
  const [filter, setFilter] = useState({
    type: "",
    startDate: "",
    endDate: ""
  });
  const [CSV, setCSV] = useState([])
  const [externalBalance, setExternalBalance] = useState({})

  const requiredConstants = useSelector((state) => state.constants);
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  let isLoanAdmin = sessionStorage.getItem("isLoanAdmin");
  let configVariables = useSelector((state) => state.config.baseConfig);
  
  const portalLogo = configVariables.logoURL;
  let isDevEnv = configVariables.devEnvironment;

  async function getUserExternalAcctBalance(piid) {
    // console.log(selectedExternalAccount)
    let response = await getExternalAccountBalance(selectedUser, piid);
    // console.log(response.payload)
    setExternalBalance(response?.payload || {});
  }

  useEffect(() => {
    getUserOptions();
    getTransactionOptions();
  }, []);

  // const decodeHTMLEntities = (text) => {
  //   const parser = new DOMParser();
  //   const decode = (str) => parser.parseFromString(str, 'text/html').documentElement.textContent;
  //   console.log("decodeHTMLEntitiesStrrrr--------",text);
  //   console.log("decodeHTMLEntitiesVallll--------",(decode(text)));
  //   return decode(decode(text));
  // }

  const deepDecodeHTMLEntities = (input)=> {
    if (!input) return '';
  
    const parser = new DOMParser();
    let prev = '';
    let current = input;
  
    // Keep decoding until the result stops changing
    while (current !== prev) {
      prev = current;
      current = parser.parseFromString(current, 'text/html').documentElement.textContent || '';
    }
  
    return current;
  };

  // console.log(externalBalance)

  // console.log("transactionHistory----------",transactionHistory)

  console.log(type === "voucherHistory" ? "Voucher History" : "Transaction History")

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const user = useSelector((state) => state.usersList.userID);
  console.log(user)

  const handleClose = () => {
    setOpen(false);
  }

  const handleSelect = (value, filterData) => {
    console.log(value)
    console.log(filterData)
  }

  const handleDate = (date) => {
    console.log(date);
  }

  const handleApply = async(data, formData) => {

      console.log("Data submitted:", data);
      setFilter({
        ...filter,
        type: data['type'],
        startDate: data['startdate'],
        endDate: data['enddate']
      })

      handleClose();
  }

  const getTransactionData = async () => {
    const response = await listVouchers(selectedUser);
    let transactions = [];
  
    if (response.data) {
      if (response.data?.body?.record?.length) {
        transactions = response.data?.body?.record;
      } else if (response.data?.body?.record) {
        transactions = [response.data?.body?.record];
      }
    }
  
    if (isSuperAdmin === 'false' && isLoanAdmin === 'false') {
      transactions = transactions.filter((transaction) => {
        const msg = transaction?.Vtranshistorybyuser2?.msg;
        const clerk = transaction?.Vtranshistorybyuser2?.clerkname;
  
        const msgLower = typeof msg === 'string' ? msg.toLowerCase() : "";
        const clerkLower = typeof clerk === 'string' ? clerk.toLowerCase() : "";
  
        return !msgLower.includes("loan") && !clerkLower.includes("loan");
      });
    }
  
    if (filter.startDate || filter.endDate) {
      const startDate = new Date(filter.startDate);
      const endDate = new Date(filter.endDate);
  
      transactions = transactions.filter((transaction) => {
        const transTime = new Date(transaction?.Vtranshistorybyuser2?.transTime);
        if (filter.startDate && filter.endDate) {
          return transTime >= startDate && transTime <= endDate;
        } else if (filter.startDate) {
          return transTime >= startDate;
        } else if (filter.endDate) {
          return transTime <= endDate;
        }

        console.log("details to see for loans",isSuperAdmin, isLoanAdmin, transactions)
  
        if (isSuperAdmin === 'false' && isLoanAdmin === 'false') {
          const clerk = transaction?.Vtranshistorybyuser2?.clerkname || "";
          return !clerk.toLowerCase().includes("loan");
        }
  
        return true;
      });
    }
  
    setTransactionHistory(transactions);
    setLoading(false);
  };
  
  

  useEffect(() => {

    async function getUserAccounts() {
      let response = await getExternalAccounts(selectedUser);
      let records = response.payload?.record;
      if (!records) return;
      if (!Array.isArray(records)) {
        records = [records];
      }

      const transactionAccounts = records.filter(
        (account) => account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
      );
      const otherAccounts = records.filter(
        (account) => !account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
      );

      const sortedAccounts = transactionAccounts.concat(otherAccounts);

      setExternalAccounts(sortedAccounts);
    }
    getUserAccounts();

    getTransactionData();
  }, [selectedUser]);

  useEffect(() => {
    if (filter.type || filter.startDate || filter.endDate) {
      getTransactionData();
    }
  }, [filter]);

  useEffect(() => {
    if (externalAccounts?.length > 0) {
      setSelectedExternalAccount(`${externalAccounts[0]?.Vuserpi3.id}-${externalAccounts[0]?.Vuserpi3.piid}`);
      getUserExternalAcctBalance(externalAccounts[0]?.Vuserpi3.id)
    }
  }, [externalAccounts]);  

  useEffect(() => {
   setFilter({
    type: "",
    startDate: "",
    endDate: ""
   })
  }, [selectedExternalAccount]);

  const formatTransactionHistoryForCSV = (transactions) => {
    if (type === "voucherHistory") {
      return transactions.map((transaction) => ({
        Date: transaction?.Vnodetransferpool?.transferTime,
        Type: transaction?.Vnodetransferpool?.typelabel,
        "Transaction ID": transaction?.Vnodetransferpool?.txid || "N/A", 
        Recipient: transaction?.Vnodetransferpool?.recipientname,
        Amount: transaction?.Vnodetransferpool?.amountRecipient,
      }));
    }

    return transactions.map((transaction) => ({
      Date: transaction?.Vtranshistorybyuser2?.transTime,
      Type: transaction?.Vtranshistorybyuser2?.transtypelabel,
      "External ID": transaction?.Vtranshistorybyuser2?.externalrefid || "N/A",
      Comment: deepDecodeHTMLEntities(transaction?.Vtranshistorybyuser2?.msg),
      Vendor: transaction?.Vtranshistorybyuser2?.clerkname,
      Amount: transaction?.Vtranshistorybyuser2?.amount,
    }));
  };

  useEffect(() => {
    if (csvData) {
      setCSV(formatTransactionHistoryForCSV(csvData))
    }
    else {
      setCSV([])
    }
  }, [csvData])

  function formatDate(date) {
    // Convert date to yyyy-mm-dd
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2,"0");
    const day = String(date.getDate()).padStart(2,"0");
    return `${year}-${month}-${day}`;
  }

  const cleanAndAbsValue = (value) => {
    if (typeof value === 'string') {
        // Remove dollar sign and convert to a number
        const numericValue = parseFloat(value.replace(/[$,]/g, ''));
        return Math.abs(numericValue); // Return absolute value
    }
    return Math.abs(parseFloat(value)); // For numbers, directly return abs value
};
  
    // const handlePDFDownload = async () => {
    //   console.log(user)
    //   try {
    //     let response

    //     console.log(externalAccounts, selectedExternalAccount)

    //     const accountName = externalAccounts.find(
    //       (account) => `${account.Vuserpi3.id}-${account.Vuserpi3.piid}` === selectedExternalAccount
    //     )

    //     console.log(accountName)

    //     const accountBalance = await getExternalAccountBalance(selectedUser, accountName?.Vuserpi3?.id)

    //     console.log(accountBalance)

    //     console.log(accountName.Vuserpi3.friendlyname)
    //     console.log(user)
    //     console.log(externalBalance)

    //    // Convert each date string to a Date object and collect them
    //    console.log(csvData)
    //    let deposits, depositTotal, withdrawals, withdrawalTotal

    //    let dateObjects
    //    if (type === "transactionHistory") {
    //     dateObjects = csvData.map(item => new Date(item.Vtranshistorybyuser2.transTime));
    //    }
    //    else {
    //     dateObjects = csvData.map(item => new Date(item.Vnodetransferpool.transferTime));
    //    }

    //     // Find the earliest and latest dates
    //     const earliestDate = formatDate(new Date(Math.min(...dateObjects)));
    //     const latestDate = formatDate(new Date(Math.max(...dateObjects)));

    //     console.log(earliestDate, latestDate)
        
    //     if (type === "voucherHistory") {

    //       deposits = csvData.filter((transaction) => transaction.Vnodetransferpool?.type === "58");

    //       depositTotal = deposits.reduce((sum, transaction) => {
    //         return sum + (parseInt(transaction.Vnodetransferpool.amountRecipient) || 0); 
    //       }, 0);

    //       withdrawals = csvData.filter((transaction) => 
    //         transaction.Vnodetransferpool?.type === "1" ||
    //         transaction.Vnodetransferpool?.type === "3" ||
    //         transaction.Vnodetransferpool?.type === "68" ||
    //         transaction.Vnodetransferpool?.type === "42" 
    //     );

    //       withdrawalTotal = withdrawals.reduce((sum, transaction) => {
    //         return sum + (parseInt(transaction.Vnodetransferpool.amountRecipient) || 0); 
    //       }, 0);

    //       const formattedCsvData = await csvData.map((item) => {
    //         if (item.Vtranshistorybyuser2 && item.Vtranshistorybyuser2.msg) {
    //           item.Vtranshistorybyuser2.msg = deepDecodeHTMLEntities(item.Vtranshistorybyuser2.msg);
    //         }
          
    //         if (item.msg) {
    //           item.msg = deepDecodeHTMLEntities(item.msg);
    //         }
          
    //         return item;
    //       }).filter((item) => {
    //         return item;
    //       });

    //       response = await runPDFVH(
    //         filter.startDate ? formatDate(filter.startDate) : earliestDate, 
    //         filter.endDate ? formatDate(filter.endDate) : latestDate, 
    //         formattedCsvData,
    //         accountName?.Vuserpi3?.friendlyname,
    //         deepDecodeHTMLEntities(user['User'].firstName),
    //         deepDecodeHTMLEntities(user['User'].lastName),
    //         // Math.abs(parseFloat(accountBalance?.payload?.balance)),
    //         parseFloat(accountBalance?.payload?.balance),
    //         cleanAndAbsValue(accountBalance?.payload?.unavailablebalance) ,
    //         withdrawalTotal,
    //         depositTotal
    //       );
    //     }
    //     else {

    //       deposits = csvData.filter((transaction) => transaction.Vtranshistorybyuser2?.transType === "58");

    //       depositTotal = deposits.reduce((sum, transaction) => {
    //         return sum + (parseInt(transaction.Vtranshistorybyuser2.amount) || 0); 
    //       }, 0);

    //       withdrawals = csvData.filter((transaction) => 
    //         transaction.Vtranshistorybyuser2?.transType === "1" || 
    //         transaction.Vtranshistorybyuser2?.transType === "3" ||
    //         transaction.Vtranshistorybyuser2?.transType === "68" || 
    //         transaction.Vtranshistorybyuser2?.transType === "42"
    //       );

    //       withdrawalTotal = withdrawals.reduce((sum, transaction) => {
    //         return sum + (Math.abs(parseInt(transaction.Vtranshistorybyuser2.amount)) || 0); 
    //       }, 0);

    //       const formattedCsvData = await csvData.map((item) => {
    //         if (item.Vtranshistorybyuser2 && item.Vtranshistorybyuser2.msg) {
    //           item.Vtranshistorybyuser2.msg = deepDecodeHTMLEntities(item.Vtranshistorybyuser2.msg);
    //         }
          
    //         if (item.msg) {
    //           item.msg = deepDecodeHTMLEntities(item.msg);
    //         }
          
    //         return item;
    //       }).filter((item) => {
    //         return item;
    //       });

    //       response = await runPDFTH(
    //         filter.startDate ? formatDate(filter.startDate) : earliestDate, 
    //         filter.endDate ? formatDate(filter.endDate) : latestDate, 
    //         formattedCsvData,
    //         accountName?.Vuserpi3?.friendlyname,
    //         deepDecodeHTMLEntities(user['User'].firstName),
    //         deepDecodeHTMLEntities(user['User'].lastName),
    //         parseFloat(accountBalance?.payload?.balance),
    //         cleanAndAbsValue(accountBalance?.payload?.unavailablebalance) ,
    //         withdrawalTotal,
    //         depositTotal
    //       );
    //     }
    //     console.log(response)
    //     if (response?.download) {
    //       // Open the generated PDF
    //       window.open(`${configVariables.baseURL + configVariables.receiptExtension}/${response.download}`, "_blank");

    //       const response2 = await deleteFile(response.download)

    //   console.log(response2)
    //     } else {
    //       console.log("Failed to generate PDF");
    //     }
    //   } catch (error) {
    //     console.error("Error generating PDF:", error);
    //   }
    // };

    // const loadLogoAsBase64 = async(url) => {
    //   const response = await fetch(url);
    //   const svgText = await response.text();
    
    //   // Create a temporary canvas
    //   const svgBlob = new Blob([svgText], { type: 'image/svg+xml' });
    //   const urlObject = URL.createObjectURL(svgBlob);
    //   const img = new Image();
    //   img.src = urlObject;
    
    //   return new Promise((resolve) => {
    //     img.onload = () => {
    //       const canvas = document.createElement('canvas');
    //       canvas.width = img.width;
    //       canvas.height = img.height;
    //       const ctx = canvas.getContext('2d');
    //       ctx.drawImage(img, 0, 0);
    //       URL.revokeObjectURL(urlObject);
    //       resolve(canvas.toDataURL('image/png')); // Returns base64 PNG
    //     };
    //   });
    // }

    // const loadLogoAsBase64 = async (svgUrl) => {
    //   const response = await fetch(svgUrl);
    //   const svgText = await response.text();

    //   const svgBlob = new Blob([svgText], { type: "image/svg+xml" });
    //   const url = URL.createObjectURL(svgBlob);

    //   return new Promise((resolve) => {
    //     const img = new Image();
    //     img.onload = () => {
    //       const canvas = document.createElement("canvas");
    //       canvas.width = img.width;
    //       canvas.height = img.height;
    //       const ctx = canvas.getContext("2d");
    //       ctx.drawImage(img, 0, 0);
    //       URL.revokeObjectURL(url);
    //       resolve(canvas.toDataURL("image/png")); // ✅ gives PNG base64
    //     };
    //     img.src = url;
    //   });
    // };

    const loadLogoAsBase64 = async (url) => {
      const response = await fetch(url);
      const svgText = await response.text();
    
      return new Promise((resolve, reject) => {
        const img = new Image();
        // Encode SVG into base64
        img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgText)));
    
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width || 200;  // fallback size
          canvas.height = img.height || 100;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png")); // ✅ proper PNG base64
        };
    
        img.onerror = (err) => reject(err);
      });
    };

    const handlePDFDownload = async () => {
      console.log(user)
      try {
        let response

        console.log(externalAccounts, selectedExternalAccount)

        const accountName = externalAccounts.find(
          (account) => `${account.Vuserpi3.id}-${account.Vuserpi3.piid}` === selectedExternalAccount
        )

        // console.log(accountName)

        const accountBalance = await getExternalAccountBalance(selectedUser, accountName?.Vuserpi3?.id)

        // console.log(accountBalance)

        // console.log(accountName.Vuserpi3.friendlyname)
        // console.log(user)
        // console.log(externalBalance)

       // Convert each date string to a Date object and collect them
       console.log(csvData)
       let deposits, depositTotal, withdrawals, withdrawalTotal

       let dateObjects
       if (type === "transactionHistory") {
        dateObjects = csvData.map(item => new Date(item.Vtranshistorybyuser2.transTime));
       }
       else {
        dateObjects = csvData.map(item => new Date(item.Vnodetransferpool.transferTime));
       }

        // Find the earliest and latest dates
        const earliestDate = formatDate(new Date(Math.min(...dateObjects)));
        const latestDate = formatDate(new Date(Math.max(...dateObjects)));

        console.log(earliestDate, latestDate)
        
        if (type === "voucherHistory") {

          deposits = csvData.filter((transaction) => transaction.Vnodetransferpool?.type === "58");

          depositTotal = deposits.reduce((sum, transaction) => {
            return sum + (parseInt(transaction.Vnodetransferpool.amountRecipient) || 0); 
          }, 0);

          withdrawals = csvData.filter((transaction) => 
            transaction.Vnodetransferpool?.type === "1" ||
            transaction.Vnodetransferpool?.type === "3" ||
            transaction.Vnodetransferpool?.type === "68" ||
            transaction.Vnodetransferpool?.type === "42" 
        );

          withdrawalTotal = withdrawals.reduce((sum, transaction) => {
            return sum + (parseInt(transaction.Vnodetransferpool.amountRecipient) || 0); 
          }, 0);

          const formattedCsvData = await csvData.map((item) => {
            if (item.Vtranshistorybyuser2 && item.Vtranshistorybyuser2.msg) {
              item.Vtranshistorybyuser2.msg = deepDecodeHTMLEntities(item.Vtranshistorybyuser2.msg);
            }
          
            if (item.msg) {
              item.msg = deepDecodeHTMLEntities(item.msg);
            }
          
            return item;
          }).filter((item) => {
            return item;
          });

          response = await runPDFVH(
            filter.startDate ? formatDate(filter.startDate) : earliestDate, 
            filter.endDate ? formatDate(filter.endDate) : latestDate, 
            formattedCsvData,
            accountName?.Vuserpi3?.friendlyname,
            deepDecodeHTMLEntities(user['User'].firstName),
            deepDecodeHTMLEntities(user['User'].lastName),
            // Math.abs(parseFloat(accountBalance?.payload?.balance)),
            parseFloat(accountBalance?.payload?.balance),
            cleanAndAbsValue(accountBalance?.payload?.unavailablebalance) ,
            withdrawalTotal,
            depositTotal
          );
        }
        else {
          deposits = csvData.filter((transaction) => transaction.Vtranshistorybyuser2?.transType === "58");

          depositTotal = deposits.reduce((sum, transaction) => {
            return sum + (parseInt(transaction.Vtranshistorybyuser2.amount) || 0); 
          }, 0);

          withdrawals = csvData.filter((transaction) => 
            transaction.Vtranshistorybyuser2?.transType === "1" || 
            transaction.Vtranshistorybyuser2?.transType === "3" ||
            transaction.Vtranshistorybyuser2?.transType === "68" || 
            transaction.Vtranshistorybyuser2?.transType === "42"
          );

          withdrawalTotal = withdrawals.reduce((sum, transaction) => {
            return sum + (Math.abs(parseInt(transaction.Vtranshistorybyuser2.amount)) || 0); 
          }, 0);

          let accountDeposits = 0.00;
	        let accountWithdrawals = 0.00;
          let bal = parseFloat(accountBalance?.payload?.balance) || 0;
          let displayBal = bal < 0 ? Math.abs(bal) : -bal;
          
          

          const formattedCsvData = await csvData.map((item) => {
            if (item.Vtranshistorybyuser2 && item.Vtranshistorybyuser2.msg) {
              item.Vtranshistorybyuser2.msg = deepDecodeHTMLEntities(item.Vtranshistorybyuser2.msg);
            }
          
            if (item.msg) {
              item.msg = deepDecodeHTMLEntities(item.msg);
            }
          
            accountDeposits = accountDeposits + parseFloat(item?.Vtranshistorybyuser2?.creditamount);
            accountWithdrawals = accountWithdrawals + parseFloat(item?.Vtranshistorybyuser2?.debitamount);

            return item;
          }).filter((item) => {
            return item;
          });

          let accWith = parseFloat(accountWithdrawals) || 0;
          let displayAccWithdrawals = accWith < 0 ? Math.abs(accWith) : -accWith;

          const doc = new jsPDF({
            orientation: 'landscape', // makes it wider
            unit: 'mm',               // measurement unit
            format: 'a4'              // standard A4 size
          });
          doc.setFontSize(16);

          const logoBase64 = await loadLogoAsBase64(portalLogo);
          doc.addImage(logoBase64, 'PNG', 10, 10, 30, 15);
          // Company name & address under the logo
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(isDevEnv ? "PAiY Digital Wallet" : "RÊVE - Rêve Digital Wallet", 10, 30);

          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.text(isDevEnv ? "95 Mural Street," : "6 Parade Avenue Butterfield Square", 10, 35);
          doc.text(isDevEnv ? "Richmond Hill, Ontario," : "Providenciales", 10, 40);
          doc.text(isDevEnv ? "L4B 3G2   Canada" : "Turks and Caicos Islands", 10, 45);
          doc.text(isDevEnv ? "" : "TKCA 1ZZ   British West Indies", 10, 50);

          // Account info on the right
          doc.setFontSize(14);
          doc.setFont("helvetica", "bold");
          doc.text("Account Statement", doc.internal.pageSize.getWidth() - 10, 20, { align: "right" });

          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text(`Account Name: ${deepDecodeHTMLEntities(user['User'].firstName)} ${deepDecodeHTMLEntities(user['User'].lastName)}`, doc.internal.pageSize.getWidth() - 10, 28, { align: "right" });
          doc.text(`Account Type: ${accountName?.Vuserpi3?.friendlyname}`, doc.internal.pageSize.getWidth() - 10, 33, { align: "right" });
          doc.text(`Currency: USD`, doc.internal.pageSize.getWidth() - 10, 38, { align: "right" });
          doc.text(`${filter.startDate ? formatDate(filter.startDate) : earliestDate} to ${filter.endDate ? formatDate(filter.endDate) : latestDate}`, doc.internal.pageSize.getWidth() - 10, 43, { align: "right" });

          // Now add a gap before the table starts
          let y = 60;

          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");

          const selectedId = selectedExternalAccount.split('-')[0];
          const matchedAccount = await externalAccounts.find(
            (item) => item.Vuserpi3.id === selectedId
          );

          let accName = matchedAccount?.Vuserpi3?.friendlyname;
          let last4digits = matchedAccount?.Vuserpi3?.cardno?.slice(-4);

          if(matchedAccount?.Vuserpi3?.piid == "229" || matchedAccount?.Vuserpi3?.piid == "230") {
            doc.text(`Account Summary: ${matchedAccount?.Vuserpi3?.friendlyname}`, 10, y);
          } else {
            doc.text(`Account Summary: ${accName} - ${last4digits}`, 10, y);
          }
          
          // doc.text("Account Summary: Transactions Account-517023", 10, y);
          y += 8;

          const cellHeight = 10;
          const cellWidth = (doc.internal.pageSize.getWidth() - 30) / 2; // two cells per row
          const cellPadding = 3;
          doc.setFillColor(240, 240, 240); 

          // Row 1
          doc.rect(10, y, cellWidth, cellHeight, 'F');
          doc.rect(10 + cellWidth + 10, y, cellWidth, cellHeight, 'F');
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text(`Available Balance: $${parseFloat(displayBal).toFixed(2)}`, 10 + cellPadding, y + 6);
          doc.text(`Total Account Deposits: $${parseFloat(accountDeposits).toFixed(2)}`, 10 + cellWidth + 10 + cellPadding, y + 6);
          y += cellHeight + 5;

          // Row 2
          doc.setFillColor(240, 240, 240); 
          doc.rect(10, y, cellWidth, cellHeight, 'F');
          doc.rect(10 + cellWidth + 10, y, cellWidth, cellHeight, 'F');
          doc.text(`Unavailable Balance: $${cleanAndAbsValue(accountBalance?.payload?.unavailablebalance).toFixed(2)}`, 10 + cellPadding, y + 6);
          doc.text(`Total Account Withdrawals: $${parseFloat(displayAccWithdrawals).toFixed(2)}`, 10 + cellWidth + 10 + cellPadding, y + 6);
          y += cellHeight + 10;

          // Account Activity Details Title
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text("Account Activity Details", 10, y);
          y += 8;
        
          // Define base Y and line spacing
          // let y = 22;
          const lineSpacing = 10;

          const headers = [
            "Date",
            "Type",
            "External ID",
            "Comments",
            "Vendor",
            "Debit",
            "Credit"
          ];

          // doc.setFontSize(14);
          // doc.setFont("helvetica", "bold");
          // doc.text("Transaction Report",doc.internal.pageSize.getWidth() / 2, y, { align: "center" });
          // y += lineSpacing;

          const body = formattedCsvData.map(row => {
            // console.log("Row--------",row);
            return [
              row?.Vtranshistorybyuser2?.transTime?.split(" ")[0] || "",
              row?.Vtranshistorybyuser2?.transtypelabel || "",
              row?.Vtranshistorybyuser2?.externalrefid || "",
              row?.Vtranshistorybyuser2?.msg || "",
              decodeHtmlEntities(row?.Vtranshistorybyuser2?.clerkname) || "",
              row?.Vtranshistorybyuser2?.debitamount || "",
              row?.Vtranshistorybyuser2?.creditamount || "",
            ];
          });

          autoTable(doc, {
            head: [headers], // must be an array of arrays
            body,
            startY: y,
            styles: { fontSize: 8, cellPadding: 2, lineWidth: 0.1, color:'black' },
            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: 'bold' },
            bodyStyles: { textColor: [0, 0, 0] },
          });

          const somenum = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
          doc.save(`file${somenum}.pdf`);

          // response = await runPDFTH(
          //   filter.startDate ? formatDate(filter.startDate) : earliestDate, 
          //   filter.endDate ? formatDate(filter.endDate) : latestDate, 
          //   formattedCsvData,
          //   accountName?.Vuserpi3?.friendlyname,
          //   deepDecodeHTMLEntities(user['User'].firstName),
          //   deepDecodeHTMLEntities(user['User'].lastName),
          //   parseFloat(accountBalance?.payload?.balance),
          //   cleanAndAbsValue(accountBalance?.payload?.unavailablebalance) ,
          //   withdrawalTotal,
          //   depositTotal
          // );
        }
        // console.log(response)
      //   if (response?.download) {
      //     // Open the generated PDF
      //     window.open(`${configVariables.baseURL + configVariables.receiptExtension}/${response.download}`, "_blank");

      //     const response2 = await deleteFile(response.download)

      // console.log(response2)
      //   } else {
      //     console.log("Failed to generate PDF");
      //   }
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    };

    async function getTransactionOptions() {
      let transactionOptions = requiredConstants.transactionTypes.map((transaction) => {
        return {
          key: transaction.Vtranstype.typeID,
          value: transaction.Vtranstype.typeID,
          label: transaction.Vtranstype.label,
      }});
  
      transactionOptions.unshift({
        key: "alltransactions",
        value: 0,
        label: "All Transactions", 
      })
  
      setOptions((prevOptions) => ({
        ...prevOptions,
        type: transactionOptions,
      }));
      // console.log(options)
    }
  
  
    async function getUserOptions() {

  
      setOptions((prevOptions) => ({
        ...prevOptions,
        user: [],
      }));
      // console.log(options)
    }

    // console.log(CSV)


  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >

          <DynamicFilter
            filterName="filterTest"
            open={open}
            handleClose={handleClose}
            handleSelect={handleSelect}
            handleDate={handleDate}
            setFilter={setFilter}
            userHeader={"Transaction Report Filter"}
            onSubmit={handleApply}
            filterOptions={options}
            filters={filter}

          />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {externalAccounts.length > 0 && (
            <>
              <Typography
                sx={{
                  fontWeight: 800,
                  color: "#6b7280",
                  fontSize: "14px",
                  fontFamily: "Nunito",
                }}
              >
                Account Types
              </Typography>
              <Select
                value={selectedExternalAccount}
                onChange={(e) => setSelectedExternalAccount(e.target.value)}
                sx={{
                  '& .MuiSelect-select': {
                    padding: "6px",
                    fontSize: "14px",
                  },
                }}
              >
                {externalAccounts.map((account) => {
                  const { friendlyname, cardno, piid, status, id } = account.Vuserpi3;

                  const last4 = cardno?.slice(-4);
                  const showCardDigits = piid !== "229" && piid !== "230" && last4;

                  let label = friendlyname;
                  if (status === "2") label += " (BLOCKED)";
                  if (showCardDigits) label += ` - ${last4}`;

                  return (
                    <MenuItem key={`${id}-${piid}`} value={`${id}-${piid}`}>
                      {label}
                    </MenuItem>
                  );
                })}
                {/* {externalAccounts.map((account) => (
                  <MenuItem
                    key={`${account.Vuserpi3.id}-${account.Vuserpi3.piid}`}
                    value={`${account.Vuserpi3.id}-${account.Vuserpi3.piid}`}
                  >
                    {account?.Vuserpi3?.status === "2" ? `${account?.Vuserpi3?.friendlyname} (BLOCKED)` : account?.Vuserpi3?.friendlyname}
                  </MenuItem>
                ))} */}
              </Select>
            </>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            alignItems: "right",
            gap: "10px",
            marginLeft: "auto",
          }}
        >
          <CSVLink
            data={CSV}
            filename={`PAiY-TR-${new Date().toISOString().slice(0, 10)}.csv`}
            style={{ textDecoration: "none" }}
          >
            <IconButton
              sx={{
                width: 40,
                height: 40,
                color: "#6c757d",
                "&:hover": {
                  backgroundColor: "rgba(108, 117, 125, 0.1)",
                },
              }}
            >
              <img src={csvImage} alt="CSV" loading="lazy" />
            </IconButton>
          </CSVLink>
          {type !== "voucherHistory" && <IconButton
          onClick={() => handlePDFDownload()}
            sx={{
              width: 40,
              height: 40,
              color: "#6c757d",
              "&:hover": {
                backgroundColor: "rgba(108, 117, 125, 0.1)",
              },
            }}
          >
            <img src={pdfImage} alt="PDF" loading="lazy" />
          </IconButton>}
            <BaseButton 
              buttonText={"Filter"} 
              buttonStyle="secondary-button-style"
              onClick={() => setOpen(true)}
            />
        </Box>
      </Box>
  
      <Box>
        {loading ? (
          <Box sx={{ textAlign: "center", marginTop: "50px" }}>
            <span className="loader" />
          </Box>
        ) : (
          <CustomerTransactionTable
            type={type}
            transactionHistory={transactionHistory}
            selectedExternalAccount={selectedExternalAccount}
            table={table}
            setTable={setTable}
            setCsvData={setCsvData}
            filter={filter}
          />
        )}
      </Box>
    </>
  );
  
}

export default TransactionTab;
